import { render } from "./NewReportCases.vue?vue&type=template&id=67089ab5"
import script from "./NewReportCases.vue?vue&type=script&lang=js"
export * from "./NewReportCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/NewReportCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67089ab5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67089ab5', __exports__)) {
    console.log('reload')
    api.reload('67089ab5', __exports__)
  }
  
  module.hot.accept("./NewReportCases.vue?vue&type=template&id=67089ab5", () => {
    console.log('re-render')
    api.rerender('67089ab5', render)
  })

}


export default __exports__